import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export interface UIState {
  isScrolled: boolean
}

export const useUIStore = defineStore('ui', () => {
    // State using ref - initialize with current scroll position
    const isScrolled = ref(window.scrollY > 50);
    const scrollListenerCount = ref(0);

    // Getters using computed
    const getIsScrolled = computed(() => isScrolled.value);

    // Actions as regular functions
    function setScrolled(scrolled: boolean) {
        isScrolled.value = scrolled;
    }

    function handleScroll() {
        const newScrolled = window.scrollY > 50;
        if (isScrolled.value !== newScrolled) {
            isScrolled.value = newScrolled;
            console.log('Scroll state changed:', newScrolled, 'scrollY:', window.scrollY);
        }
    }

    function initScrollListener() {
        if (scrollListenerCount.value === 0) {
            // Set initial state
            handleScroll();
            window.addEventListener('scroll', handleScroll);
            console.log('Scroll listener initialized. Initial state:', isScrolled.value);
        }
        scrollListenerCount.value += 1;
    }

    function removeScrollListener() {
        scrollListenerCount.value -= 1;
        if (scrollListenerCount.value === 0) {
            window.removeEventListener('scroll', handleScroll);
            console.log('Scroll listener removed');
        }
    }

    return {
    // State
        isScrolled,
        // Getters
        getIsScrolled,
        // Actions
        setScrolled,
        handleScroll,
        initScrollListener,
        removeScrollListener,
    };
}); 
